import React from 'react'
import { Location } from './style'

export default ({ value }) => <Location>{value}</Location>
